<div class="header-container">
    <mat-card class="cardWithShadow go-back-btn" (click)="backToHome()">
        <tabler-icon name="arrow-left" size="24"></tabler-icon>
    </mat-card>

    <mat-card-title>
        <span class="badge">
            <strong>{{ distributorEmail }}</strong>
        </span>
    </mat-card-title>
</div>

<app-analytics [distributorId]="distributorId"></app-analytics>